import * as React from 'react';

import FreemiumPopover from '../freemium-popover/FreemiumPopover';

const FEATURES = ['one', 'two', 'three'];
const IMAGE_WIDTH = {
  one: 570,
  two: 550,
  three: 570
};

type Props = {
  triggerComponent?: React.ReactNode
};

const CampaignPopover = ({
  triggerComponent
}: Props) => (
  <FreemiumPopover
    name="campaign"
    items={FEATURES}
    imageWidth={IMAGE_WIDTH}
    contentClassname="campaign-popover__content"
    triggerComponent={triggerComponent}
  />
);

export default CampaignPopover;
